import useResource from "./useResource"

export default function useTask(id) {
  return useResource({ key: id && `/tasks/${id}`, mutateFromUpdate: true })
}
